var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2652 17.0547C32.2652 8.16978 25.2383 0.967163 16.5701 0.967163C7.90195 0.967163 0.875 8.16978 0.875 17.0547C0.875 25.9395 7.90195 33.1422 16.5701 33.1422C25.2383 33.1422 32.2652 25.9395 32.2652 17.0547Z",
    fill: "#ECECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6441 21.7312V23.2531C21.6441 23.5578 21.8911 23.8047 22.1957 23.8047C22.5002 23.8045 22.7466 23.5576 22.7466 23.2531V21.7312H24.2694C24.5739 21.7311 24.8203 21.4842 24.8203 21.1797C24.8203 20.8752 24.5739 20.6283 24.2694 20.6281H22.7466V19.1062C22.7466 18.8017 22.5002 18.5548 22.1957 18.5547C21.8911 18.5547 21.6441 18.8016 21.6441 19.1062V20.6281H20.1219C19.8174 20.6281 19.5703 20.875 19.5703 21.1797C19.5703 21.4843 19.8174 21.7312 20.1219 21.7312H21.6441Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6139 16.6798V13.4799C24.6139 12.4926 23.8136 11.6924 22.8264 11.6924H13.7355C13.2615 11.6924 12.8067 11.8807 12.4716 12.216L8.89662 15.791C8.19852 16.4889 8.19852 17.6208 8.89662 18.3189L12.4716 21.8938C12.8067 22.2291 13.2615 22.4174 13.7355 22.4174H17.3203",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9912 15.5287C14.777 15.5287 15.414 16.1601 15.414 16.9515C15.414 17.7373 14.7826 18.3743 13.9912 18.3743C13.2053 18.3743 12.5684 17.7429 12.5684 16.9515C12.5684 16.1657 13.1998 15.5287 13.9912 15.5287Z",
    fill: "#0E1318",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.0703125 0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.4cf8eb576b99f20e2d41ab6ffd1ddfcd.svg";
export { ForwardRef as ReactComponent };